module.exports = __webpack_public_path__ + "static/img/woman_glove_3.d466ba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/woman_glove_3.png
// module id = zXna
// module chunks = 0